import { rakutenServicesActionTypes } from './rakutenServices.constants';

const initialState = {
    services: [],
};

export function rakutenServicesReducer(state = initialState, action) {
    switch (action.type) {
        case rakutenServicesActionTypes.LOAD_SERVICES_CONFIG_REQUEST:
            return { ...state, loadingServicesConfig: true, loadingServicesConfigError: null };
        case rakutenServicesActionTypes.LOAD_SERVICES_CONFIG_SUCCESS:
            return {
                ...state,
                servicesConfig: action.servicesConfig,
                loadingServicesConfig: false,
            };
        case rakutenServicesActionTypes.LOAD_SERVICES_CONFIG_FAILURE:
            return {
                ...state,
                loadingServicesConfigError: action.error,
                loadingServicesConfig: false,
            };
        case rakutenServicesActionTypes.GET_AL_AND_NL_REQUEST:
            return { ...state, gettingALinksAndNLStatus: true };
        case rakutenServicesActionTypes.GET_AL_AND_NL_FAILURE:
            return {
                ...state,
                gettingALinksAndNLStatus: false,
                gettingALinksAndNLStatusError: action.error,
            };

        case rakutenServicesActionTypes.GET_AL_AND_NL_SUCCESS:
            return {
                ...state,
                gettingALinksAndNLStatus: false,
                services: action.agreementsAndNewsletterStatuses,
            };
        case rakutenServicesActionTypes.UPDATE_NEWSLETTER_REQUEST:
            return {
                ...state,
                services: state.services.map((item) => {
                    if (item.serviceUuid !== action.serviceUuid) {
                        return item;
                    }

                    return {
                        ...item,
                        updating: true,
                        updated: false,
                    };
                }),
            };
        case rakutenServicesActionTypes.UPDATE_NEWSLETTER_SUCCESS:
            return {
                ...state,
                services: state.services.map((item) => {
                    if (item.serviceUuid !== action.nlStatus.serviceUuid) {
                        return item;
                    }

                    return {
                        ...item,
                        nlSubscription: !item.nlSubscription,
                        updating: false,
                        updated: true,
                    };
                }),
            };
        case rakutenServicesActionTypes.UPDATE_NEWSLETTER_FAILURE:
            return {
                ...state,
                services: state.services.map((item) => {
                    if (item.serviceUuid !== action.payload.serviceUuid) {
                        return item;
                    }

                    return {
                        ...item,
                        updating: false,
                    };
                }),
            };
        case rakutenServicesActionTypes.CANCEL_MEMBERSHIP_REQUEST:
            return Object.assign({}, state, { deletingAccount: true });
        case rakutenServicesActionTypes.CANCEL_MEMBERSHIP_SUCCESS:
            return Object.assign({}, state, { deletingAccount: false });
        case rakutenServicesActionTypes.CANCEL_MEMBERSHIP_FAILURE:
            return Object.assign({}, state, {
                errorDeletingAccount: action.error,
                deletingAccount: false,
            });
        default:
            return state;
    }
}
